import { Box, type BoxProps } from '@mui/material';

interface BrandWordmarkProps extends Omit<BoxProps, 'component' | 'children'> {
  compact?: boolean;
}

export function BrandWordmark({ compact = false, sx, ...props }: BrandWordmarkProps) {
  return (
    <Box
      {...props}
      component="img"
      src="/logo.png"
      alt="Inside Gallery"
      sx={{
        display: 'block',
        width: compact ? 72 : 92,
        height: 'auto',
        objectFit: 'contain',
        ...sx,
      }}
    />
  );
}
